// eslint-disable-next-line import/no-cycle
import {
  downloaAllDocRL
} from '@/api/requestlist.api'

export const DOWNLOAD_ALL_DOC_RL = 'DOWNLOAD_ALL_DOC_RL'
export const DOWNLOAD_ALL_DOC_RL_LOADING = 'DOWNLOAD_ALL_DOC_RL_LOADING'
export const DOWNLOAD_ALL_DOC_RL_DONE = 'DOWNLOAD_ALL_DOC_RL_DONE'
export const DOWNLOAD_ALL_DOC_RL_ERROR = 'DOWNLOAD_ALL_DOC_RL_ERROR'

export default {
  [DOWNLOAD_ALL_DOC_RL] (context, { id, requestNumber, requestType }) {
    context.commit(DOWNLOAD_ALL_DOC_RL_LOADING)
    return downloaAllDocRL(id, requestNumber, requestType)
      .then((response) => {
        context.commit(DOWNLOAD_ALL_DOC_RL_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_ALL_DOC_RL_ERROR, error)
        context.dispatch('notif/SET_NOTIF', { res: error, type: 'error', topic: `DOWNLOAD ALL DOC ${requestType.toUpperCase()}` }, { root: true })
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/requestlist/actions.js